<template>
	<div :class="downloadManagerClass" class="download-manager">
		<div>
			<template v-for="(download, downloadIndex) in downloads">
				<AppFileDownload
					v-if="!download.stream" :compact="compact" :filename="download.filename"
					:progress-event="download.progress" :request-id="download.uniqueId"/>
				<AppFileStreamDownload
					v-else :compact="compact" :filename="download.filename" :progress-event="download.progress"
					:request-id="download.uniqueId"/>
			</template>
		</div>
	</div>
</template>
<script>
import AppFileDownload from "@/components/AppFileDownload.vue";
import AppFileStreamDownload from "@/components/AppFileStreamDownload.vue";
import {mapGetters, mapState} from "vuex";

export default {
	components: {
		AppFileDownload,
		AppFileStreamDownload,
	},
	computed: {
		...mapState("downloadsStore", [
			"downloads",
		]),
		...mapGetters("downloadsStore", [
			"isDownloading",
		]),
		downloadManagerClass() {
			return {
				"download-manager__active": this.isDownloading,
			};
		},
		numberOfDownloads() {
			return Object.values(this.downloads).length;
		},
		compact() {
			return this.numberOfDownloads > 1;
		},
	},
	// methods: {
	// 	...mapActions("downloadsStore", [
	// 		"cancelDownload",
	// 	]),
	// },
};
</script>
